// Contenido del menú principal.
// Para cambiar un texto o una URL del menú, edita solo este archivo.

export const MENU_ITEMS = [
  {
    type: 'mega',
    id: 'servicios',
    label: 'Servicios',
    columns: [
      {
        title: 'Áreas',
        items: [
          {
            label: 'Consultoría neuroinclusiva',
            href: '/consultoria-neuroinclusiva',
            desc: 'Auditoría, diseño organizativo, implantación y seguimiento',
          },
          {
            label: 'Creatividad y audiovisual',
            href: '/creatividad-audiovisual',
            desc: 'Servicios para productoras, rodajes, equipos y proyectos creativos',
          },
          {
            label: 'Formación',
            href: '/formacion',
            desc: 'Neuroinclusión · IA para personas neurodivergentes · IA para profesionales · Programas para empresas',
          },
        ],
      },
      {
        title: 'Sectores',
        items: [
          { label: 'Empresas y RR. HH.', href: '/sectores/empresas-rrhh' },
          { label: 'Productoras audiovisuales', href: '/sectores/productoras-audiovisuales' },
          { label: 'Turismo y cultura', href: '/sectores/turismo-cultura' },
          { label: 'Tercer sector', href: '/sectores/tercer-sector' },
          { label: 'Instituciones', href: '/sectores/instituciones' },
        ],
      },
    ],
    footerLink: { label: 'Ver todos los servicios', href: '/servicios' },
  },
  {
    type: 'link',
    label: 'Neurocinema Project',
    href: '/neurocinema-project',
  },
  {
    type: 'dropdown',
    id: 'proyectos-recursos',
    label: 'Proyectos y recursos',
    columns: [
      {
        items: [
          { label: 'Proyectos', href: '/proyectos', desc: 'Casos y proyectos autorizados' },
          { label: 'Recursos', href: '/recursos', desc: 'Artículos y materiales divulgativos' },
        ],
      },
    ],
  },
  {
    type: 'link',
    label: 'Nosotros',
    href: '/nosotros',
  },
];

export const MENU_CTA = {
  label: 'Solicitar propuesta',
  href: '/solicitar-propuesta',
};